import useInvestorDetailStore from "../stores/investorDetailStore";
import { TICKET_SYSTEM_FOR_TENANTS, ticketSystemEnabledFor } from "../config/featureFlags";
import { useTicketAudience } from "./useTicketTaxonomy";

/** Whether the logged-in investor or tenant gets the ticket system yet. */
const useTicketSystemEnabled = (): boolean => {
  const audience = useTicketAudience();
  const investorId = useInvestorDetailStore((state) => state.investor?.investor_id);
  return audience === "tenant" ? TICKET_SYSTEM_FOR_TENANTS : ticketSystemEnabledFor(investorId);
};

export default useTicketSystemEnabled;
